<script context="module">let counter = 0;
export {};
</script>

<script>import { combineValidators } from '../validation';
import FieldTemplate from './FieldTemplate.svelte';
export let options, name = `inputselect_${counter++}`, label = `Select an option`, placeholder = null, value = '', inputStyle = '', cssClass = '', containerCssClass = '', error = null, isDirty = false, validateOnDirty = false;
export let id = `dropdown_${name}`;
export let validators = [];
export const validate = async () => {
    try {
        await combineValidators(...validators)(label, value);
        error = null;
    }
    catch (e) {
        const errorObject = e;
        error = errorObject.message || 'Unknown error';
        throw e;
    }
};
$: {
    value; // whenever value will be changed this will run
    if (validateOnDirty === true && isDirty === true) {
        validate().catch(() => undefined);
    }
}
</script>

<FieldTemplate {id} {label} {error} cssClass={containerCssClass}>
    <select
        {name}
        bind:value
        {id}
        slot="field"
        class={cssClass}
        class:validation_error={error}
        style={inputStyle}
        on:change={() => (isDirty = true)}
    >
        {#if placeholder}
            <option value="">{placeholder}</option>
        {/if}
        {#each options as option}
            <option value={option.value}>{option.name}</option>
        {/each}
    </select>
</FieldTemplate>

<style></style>
